import { useOutsideClick } from "hooks";
import { isNumeric } from "utils/helpers";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";
import styles from "./styles.module.css";

export function CustomSelectwithInput({
  onChange,
  options = [],
  placeholder,
  value,
  classes,
  showAbove = false,
  inputType = "number",
  disable = false,
}: any) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const { isDarkMode } = useAppSelector(userSettingState);
  const ref = useOutsideClick(() => {
    setIsOpen(false);
  });

  useEffect(() => {
    const option = options.find((item: any) => item.label === value);
    setSelectedOption(option);
  }, [value]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    onChange(option?.label);
    setIsOpen(false);
  };

  const filteredOption = options.filter((item: any) => {
    if (inputType === "number") {
      return item.label?.includes(value);
    }

    return item?.label?.toLowerCase()?.includes(value?.toLowerCase() || "");
  });

  return (
    <div
      className={`${styles.selectMain} ${
        isDarkMode ? styles.darkMode : ""
      } ${classes}`}
      ref={ref}
    >
      <button
        type="button"
        className={`${styles.selectBtn} ${
          !selectedOption && styles.placeholder
        }`}
        onClick={toggleDropdown}
      >
        {/* {selectedOption ? selectedOption.label : placeholder} */}
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(e: any) => {
            setIsOpen(true);
            const inputValue = e.target.value;
            if (inputType === "number") {
              if (isNumeric(inputValue) || inputValue === "") {
                onChange(e.target.value);
              }
            }
            if (inputType === "text") {
              onChange(e.target.value);
            }
          }}
          disabled={disable}
        />
      </button>

      {isOpen && (
        <ul className={`${styles.optionsList} ${showAbove ? "bottom-12" : ""}`}>
          {filteredOption?.length ? (
            filteredOption.map((option: any) => (
              <li
                key={option.value}
                className={`${styles.option} ${
                  selectedOption && selectedOption.value === option.value
                    ? styles.active
                    : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </li>
            ))
          ) : (
            <li className="text-red-500 p-2">Not Available</li>
          )}
        </ul>
      )}
    </div>
  );
}
